import locale from './locale';
export default function setLocale(custom) {
  Object.keys(custom).forEach(function (type) {
    // @ts-ignore
    Object.keys(custom[type]).forEach(function (method) {
      // @ts-ignore
      locale[type][method] = custom[type][method];
    });
  });
}